import { createFileRoute } from '@tanstack/react-router';
import { CustomersPage, type CustomersSearch } from '@/features/crm/pages/customers-page';

const STAGES = ['lead', 'booked', 'active', 'due', 'lapsed'] as const;
const SORTS = ['-createdAt', 'createdAt', 'name', '-name', '-lastVisitAt', 'nextDueAt'] as const;

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);

/** Every filter of the customer list lives in the URL so a filtered list can be shared and survives a refresh. */
export const Route = createFileRoute('/_app/customers/')({
  validateSearch: (s: Record<string, unknown>): CustomersSearch => ({
    q: str(s.q),
    tags: str(s.tags),
    tagMode: s.tagMode === 'all' ? 'all' : undefined,
    stage: STAGES.find((x) => x === s.stage),
    source: str(s.source),
    visit: s.visit === 'new' || s.visit === 'repeat' ? s.visit : undefined,
    pending: s.pending === true || s.pending === 'true' ? true : undefined,
    sort: SORTS.find((x) => x === s.sort),
    caution: s.caution === true || s.caution === 'true' ? true : undefined,
  }),
  component: CustomersPage,
});
